import { IconComponent, ImgIconComponent, SvgIconComponent } from 'public/icons/pixieworld/iconComponentType'
import React, { ComponentProps } from 'react'

// Mapping of iconCode to Icon Function Component
type PixieWorldIconMapType = Record<string, {
  svg?: React.ComponentType<ComponentProps<SvgIconComponent>>
  img?: string
}>

export const PixieWorldIconMap: PixieWorldIconMapType = {
  'chevronleft': {
    img: '/icons/pixieworld/chevronleft.svg',
  },
  'chevronright': {
    img: '/icons/pixieworld/chevronright.svg',
  },
  'anglesmallup': {
    img: '/icons/pixieworld/anglesmallup.svg',
  },
  'anglesmalldown': {
    img: '/icons/pixieworld/anglesmalldown.svg',
  },
  'handshake': {
    img: '/icons/pixieworld/handshake.svg',
  },
} as const

export type IconCodeType = keyof typeof PixieWorldIconMap

export type PixieWorldIconProps = React.ComponentProps<IconComponent> & {
  iconCode: IconCodeType
  variant?: boolean
}

export const PixieWorldIcon: React.FC<PixieWorldIconProps> = ({ iconCode, variant, svg, ...props }) => {
  const Icon = PixieWorldIconMap[variant ? `${iconCode}alt` : iconCode]

  if (Icon?.svg && (!Icon?.img || svg)) {
    // eslint-disable-next-line react/jsx-pascal-case
    return <Icon.svg { ...props as ComponentProps<typeof Icon.svg> } />
  }

  // eslint-disable-next-line
  return Icon?.img ? <img src={Icon.img} alt="" { ...props as ComponentProps<ImgIconComponent> } /> : null
}
